import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "value", "onChange", "minYear", "maxYear", "id", "disabled", "css", "style", "className", "as", "asChild", "calendarValue", "openCalendarOnFocus", "onSelectedDateChange", "showFirstDateInRangeOnOpen", "onKeyDown"];
import dayjs from "dayjs";
import { Calendar as CalendarIcon } from "lucide-react";
import React from "react";
import Popover from "../../Popover";
import TextInput from "../TextInput";
import Calendar from "./components/Calendar";
import useDatePicker from "./hooks/useDatePicker";
import { shortHandToDateObject } from "./logic";
import { BaseDatePicker } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
var DatePicker = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var name = _ref.name,
    value = _ref.value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return null;
    } : _ref$onChange,
    minYear = _ref.minYear,
    maxYear = _ref.maxYear,
    id = _ref.id,
    disabled = _ref.disabled,
    css = _ref.css,
    style = _ref.style,
    className = _ref.className,
    as = _ref.as,
    asChild = _ref.asChild,
    calendarValue = _ref.calendarValue,
    _ref$openCalendarOnFo = _ref.openCalendarOnFocus,
    openCalendarOnFocus = _ref$openCalendarOnFo === void 0 ? true : _ref$openCalendarOnFo,
    _ref$onSelectedDateCh = _ref.onSelectedDateChange,
    onSelectedDateChange = _ref$onSelectedDateCh === void 0 ? function () {
      return null;
    } : _ref$onSelectedDateCh,
    _ref$showFirstDateInR = _ref.showFirstDateInRangeOnOpen,
    showFirstDateInRangeOnOpen = _ref$showFirstDateInR === void 0 ? false : _ref$showFirstDateInR,
    _ref$onKeyDown = _ref.onKeyDown,
    onKeyDown = _ref$onKeyDown === void 0 ? function () {
      return null;
    } : _ref$onKeyDown,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var currentTime = dayjs();
  var iconButtonId = "".concat(id, "IconButton");
  var _useDatePicker = useDatePicker(onChange, onSelectedDateChange, value, openCalendarOnFocus, onKeyDown, id, iconButtonId),
    onCalendarCallbackValueChange = _useDatePicker.onCalendarCallbackValueChange,
    onTextInputValueChange = _useDatePicker.onTextInputValueChange,
    onInteractOutside = _useDatePicker.onInteractOutside,
    onIconButtonClick = _useDatePicker.onIconButtonClick,
    onInputFocus = _useDatePicker.onInputFocus,
    isOpen = _useDatePicker.isOpen,
    textValue = _useDatePicker.textValue,
    onEscapeKeyDown = _useDatePicker.onEscapeKeyDown,
    handleOnKeyDown = _useDatePicker.handleOnKeyDown;
  return /*#__PURE__*/_jsx(BaseDatePicker, {
    ref: forwardedRef,
    children: /*#__PURE__*/_jsx(Popover, {
      isOpen: isOpen,
      onInteractOutside: onInteractOutside,
      onEscapeKeyDown: onEscapeKeyDown,
      triggerElement: /*#__PURE__*/_jsx(TextInput, _extends({
        autoComplete: "off",
        maskProps: {
          presetMask: "date"
        },
        adornEnd: {
          type: "iconButton",
          props: {
            icon: /*#__PURE__*/_jsx(CalendarIcon, {}),
            onClick: onIconButtonClick,
            // Let the user tab to the next field without focusing the icon button
            tabIndex: -1,
            tooltipContent: "Toggle calendar popover",
            disabled: disabled,
            id: iconButtonId
          }
        },
        id: id,
        disabled: disabled,
        onFocus: onInputFocus,
        name: name,
        onChange: onTextInputValueChange,
        onKeyDown: handleOnKeyDown,
        value: textValue || ""
      }, restProps)),
      content: /*#__PURE__*/_jsx(Calendar, {
        showFirstDateInRangeOnOpen: showFirstDateInRangeOnOpen,
        onSelectedDateChange: onCalendarCallbackValueChange,
        selectedDate: calendarValue || shortHandToDateObject(textValue),
        name: name,
        id: id,
        minYear: minYear || currentTime.year() - 5,
        maxYear: maxYear || currentTime.year() + 5
      })
    })
  });
});
DatePicker.displayName = "DatePicker";
export default DatePicker;